<template>
  <div>
    <section
      v-if="stockCompareOnly"
      class="hero is-fullheight-with-navbar"
      :style="backgroundStyle"
    >
      <div class="hero-body">
        <div class="container is-max-desktop has-text-centered">
          <div class="box">
            <p class="title is-4 has-text-weight-bold">All done here!</p>
            <p class="subtitle is-6">
              Stock Compare lives on its own site. Click below to log in and
              get started.
            </p>
            <a
              class="button is-primary is-rounded"
              href="https://stockcompare.cazana.com"
              target="_blank"
              rel="noopener"
            >
              Open Stock Compare
            </a>
          </div>
        </div>
      </div>
    </section>
    <template v-else>
      <section class="hero" :style="backgroundStyle">
        <div class="hero-body">
          <div
            class="container is-max-desktop"
            :class="{ 'px-5': $mq !== 'mobile' }"
          >
            <div class="box search-box">
              <div class="p-2">
                <p class="title is-4 is-size-5-mobile has-text-weight-bold">
                  <span class="is-size-5" v-if="!$cazoo"
                    >Hi, enter the vehicle you
                    want&nbsp;to&nbsp;look&nbsp;up</span
                  >
                  <span v-if="$cazoo" class="is-size-5"
                    >Check the value and price history of any vehicle</span
                  >
                </p>
                <DashboardSearch />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <HistoryTable :preview="true" />
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    HistoryTable: () =>
      import('modules/account/components/history/AccountHistoryTable'),
    DashboardSearch: () =>
      import('modules/dashboard/components/DashboardSearch')
  },
  computed: {
    ...mapGetters({ stockCompareOnly: 'auth/stockCompareOnly' }),
    backgroundStyle() {
      if (this.$cazana) {
        return {
          backgroundColor: '#EFF4F0'
        }
      }
      if (this.$cazoo) {
        return {
          backgroundColor: '#D9FCE3'
        }
      }
      return {
        backgroundImage:
          'url(' +
          require(`core/img/background/${process.env.VUE_APP_TYPE}-pattern.png`) +
          ')',
        backgroundSize: 'cover'
      }
    }
  }
}
</script>

<style lang="sass">
.search-box
  background-color: $search-box-colour-background
</style>
